<div class="page" [class.page--ready]="ready()">
    @if (!blank()) {
        <div class="page__header">
            <span class="page__logo"></span>
            <span class="page__company"></span>
            <span class="page__date"></span>
        </div>
    }

    @for (block of blocks(); track $index) {
        @switch (block.kind) {
            @case ('heading') {
                <span class="b-heading"></span>
            }
            @case ('text') {
                <span class="b-text">
                    @for (width of block.widths; track $index) {
                        <span class="line" [style.width.%]="width"></span>
                    }
                </span>
            }
            @case ('list') {
                <span class="b-list">
                    @for (width of block.widths; track $index) {
                        <span class="b-list__row">
                            <span class="dot"></span>
                            <span class="line" [style.width.%]="width * 0.8"></span>
                        </span>
                    }
                </span>
            }
            @case ('callout') {
                <span class="b-callout">
                    <span class="line line--strong" style="width: 40%"></span>
                    <span class="line" style="width: 88%"></span>
                </span>
            }
            @case ('table') {
                <span class="b-table">
                    @for (row of range(block.rows); track row) {
                        <span class="b-table__row" [class.b-table__row--head]="row === 0">
                            @for (col of range(block.cols); track col) {
                                <span class="b-table__cell" [class.b-table__cell--wide]="col === 0"></span>
                            }
                        </span>
                    }
                </span>
            }
            @case ('stats') {
                <span class="b-stats">
                    @for (card of range(block.count); track card) {
                        <span class="b-stats__card">
                            <span class="value"></span>
                            <span class="line" style="width: 70%"></span>
                        </span>
                    }
                </span>
            }
            @case ('semaphore') {
                <span class="b-semaphore">
                    @for (tone of block.tones; track $index) {
                        <span class="b-semaphore__row">
                            <span class="light" [attr.data-tone]="tone"></span>
                            <span class="line" style="width: 62%"></span>
                        </span>
                    }
                </span>
            }
            @case ('photos') {
                <span class="b-photos">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            }
            @case ('signature') {
                <span class="b-signature">
                    <span></span>
                    <span></span>
                </span>
            }
            @case ('total') {
                <span class="b-total"></span>
            }
        }
    }

    @if (srcdoc(); as doc) {
        <iframe
            #frame
            class="page__frame"
            [class.page__frame--ready]="ready()"
            tabindex="-1"
            scrolling="no"
            loading="lazy"
            [srcdoc]="doc"></iframe>
    }
</div>
